import { render, staticRenderFns } from "./ruleAssetClassification.vue?vue&type=template&id=4a87ae35&scoped=true"
import script from "./ruleAssetClassification.vue?vue&type=script&lang=js"
export * from "./ruleAssetClassification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a87ae35",
  null
  
)

export default component.exports